import { CommentStateTypes, CommentActionTypes } from "./Comment.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: CommentStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const CommentReducer = (
  state: CommentStateTypes = INITIAL_STATE,
  action: any
): CommentStateTypes => {
  switch (action.type) {
    case CommentActionTypes.FETCH_ALL_COMMENT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case CommentActionTypes.FETCH_ALL_COMMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CommentActionTypes.FETCH_ALL_COMMENT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CommentActionTypes.FETCH_ALL_COMMENT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case CommentActionTypes.FETCH_ONE_COMMENT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case CommentActionTypes.FETCH_ONE_COMMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case CommentActionTypes.FETCH_ONE_COMMENT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CommentActionTypes.FETCH_ONE_COMMENT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default CommentReducer;
